var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.186 1.542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.793,20.956a.845.845,0,0,1-.843-.844A6.132,6.132,0,0,0,3.483,15.776a6.088,6.088,0,0,0-1.8,4.335.844.844,0,1,1-1.687,0,7.828,7.828,0,0,1,4.774-7.2,7.632,7.632,0,0,1,.97-.337A6.467,6.467,0,0,1,1.362,6.455,6.453,6.453,0,0,1,12.38,1.892a6.449,6.449,0,0,1,0,9.126,6.388,6.388,0,0,1-2.491,1.552,8.162,8.162,0,0,1,.97.337,7.833,7.833,0,0,1,4.779,7.2A.845.845,0,0,1,14.793,20.956ZM7.814,1.688a4.767,4.767,0,1,0,4.767,4.767A4.773,4.773,0,0,0,7.814,1.688Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessed);
export default __webpack_public_path__ + "static/media/processed.b865e69e.svg";
export { ForwardRef as ReactComponent };